<template>
  <div class="page">
    <Header
      :setting="{
        title: '預約掛號',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div
      v-if="composable.member.info.clinic==='璟馨'"
      class="page__text ba--default border-radius-2 pv2 ph3 align--left mb5"
    >
      <div class="mb3 align--left">
        歡迎使用 璟馨婦幼醫院 網路掛號系統<br>
        每年10月配合政府施打流感疫苗政策，於門診時段提供流感疫苗接種，其餘時段視政府政策調整，詳情請洽詢掛號櫃台
      </div>
      1.網路掛號如無故未到，累積三次，則停止預約掛號三個月，須到現場掛號後始可再行預約<br>
      2.當日如已開診，將不受理網路預約掛號，請於開診前準時掛號，<br>
      當日早診網路掛號時間為早上8:00前   (請於11:30前報到) <br>
      當日午診網路掛號時間為中午12:00前   (請於17:15前報到) <br>
      當日晚診網路掛號時間至晚上18:00前   (請於20:45前報到) <br>
      3.初診需填個人資料，不開放網路預約，需以電話人工預約方式或親至現場預約辦理， <br>
      初診掛號現場有提供保留。 <br>
      4.乳房中心/直腸外科 【男性病患僅提供門診諮詢服務，無開放手術治療】<br> <br>

      電話：06-3023366
    </div>
    <div
      v-if="composable.member.info.clinic==='詠馨'"
      class="page__text ba--default border-radius-2 pv2 ph3 align--left mb5"
    >
      <div class="mb3 align--left">
        歡迎使用 詠馨婦產科診所 網路掛號系統<br>
        每年10月配合政府施打流感疫苗政策，於門診時段提供流感疫苗接種，其餘時段視政府政策調整，詳情請洽詢掛號櫃台
      </div>
      1.網路掛號如無故未到，累積三次，則停止預約掛號三個月，須到現場掛號後始可再行預約<br>
      2.當日如已開診，將不受理網路預約掛號，請於開診前準時掛號，<br>
      當日早診網路掛號時間為早上8:00前   (請於11:30前報到) <br>
      當日午診網路掛號時間為中午12:00前   (請於17:15前報到) <br>
      當日晚診網路掛號時間至晚上18:00前   (請於20:45前報到) <br>
      3.初診需填個人資料，不開放網路預約，需以電話人工預約方式或親至現場預約辦理， <br>
      初診掛號現場有提供保留。 <br> <br>

      電話：06-2835888
    </div>
    <div
      @click="$router.push({path: '/appointment/doctor/making'})"
      class="label label--primary mb4"
    >
      預約掛號
    </div>
    <div
      @click="$router.push({path: '/appointment/doctor/query'})"
      class="label label--secondary mb4"
    >
      查詢、取消預約
    </div>
  </div>
</template>

<script>
import composable from '@/composable/index';

export default {
  setup() {
    return {
      composable,
    };
  },
};
</script>
